
class PushService {
  isPushSupported() {
    return this.__webPushSupported() || this.__safariSupported();
  }

  getPushPermission() {
    return this.__webPushPermission() || this.__safariPermission();
  }

  isPushEnabled() {
    return new Promise((done) => {
      if (this.__safariSupported()) {
        done(this.__safariPermission() === 'granted');
      } else {
        this.__getWebPushIsEnabled().then((isEnabled) => {
          done(isEnabled);
        });
      }
    });
  }

  requestPushPermission() {
    return new Promise((done, error) => {
      if (this.__safariSupported()) {
        this.__requestSafariPushPermission().then((permissionData) => {
          if (permissionData.permission === 'denied') {
            error(new Error('Safari push permission denied'));
          } else {
            done(['safari', permissionData]);
          }
        }).catch((e) => {
          error(e);
        });
      } else {
        this.__requestWebPushPermission().then((subscription) => {
          done(['webpush', subscription]);
        }).catch((e) => {
          error(e);
        });
      }
    });
  }

  requestPushUnsubscribe() {
    if (this.__safariSupported()) {
      // Not supported
      return Promise.resolve();
    }

    return this.__requestWebPushUnsubscribe();
  }

  __webPushSupported() {
    return 'PushManager' in window && 'Notification' in window;
  }

  __webPushPermission() {
    if (!this.__webPushSupported()) {
      return null;
    }
    return window.Notification.permission;
  }

  __getWebPushIsEnabled() {
    return navigator.serviceWorker.ready.then((serviceWorker) => {
      return serviceWorker.pushManager.getSubscription().then((subscription) => {
        return subscription != null;
      });
    });
  }

  __requestWebPushPermission() {
    return navigator.serviceWorker.ready.then((serviceWorker) => {
      return serviceWorker.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: this.__base64UrlToUint8Array(
          'BD31JS_By2J02gSpF7XiZDb-r3y21RHwq0_1TZTaSCbuw9e4maRpwjsq6lP-Qii7W2AY0QS10KKXSxfuWGWA8qY=',
        ),
      });
    });
  }

  __requestWebPushUnsubscribe() {
    return navigator.serviceWorker.ready.then((serviceWorker) => {
      return serviceWorker.pushManager.getSubscription().then((subscription) => {
        if (!subscription) {
          return false;
        }

        // This deletes the subscription but doesn't delete the permission
        return subscription.unsubscribe();
      });
    });
  }

  __safariSupported() {
    return 'safari' in window && 'pushNotification' in window.safari;
  }

  __safariPermission() {
    if (!this.__safariSupported()) {
      return null;
    }

    const permissionData = window.safari.pushNotification.permission('web.co.shieldgps');
    return permissionData.permission;
  }

  __requestSafariPushPermission() {
    return new Promise((done) => {
      window.safari.pushNotification.requestPermission(
        'https://shieldgps.co/safari-push', // The web service URL.
        'web.co.shieldgps', // The Website Push ID.
        {}, // User data
        done, // The callback function.
      );
    });
  }

  __base64UrlToUint8Array = (base64UrlData) => {
    const padding = '='.repeat((4 - base64UrlData.length % 4) % 4);
    const base64 = (base64UrlData + padding)
      .replace(/\-/g, '+')
      .replace(/_/g, '/');

    const rawData = atob(base64);
    const buffer = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      buffer[i] = rawData.charCodeAt(i);
    }

    return buffer;
  }
}

export default PushService;
